import { Injectable } from '@angular/core';
import * as signalR from '@microsoft/signalr';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StripeTerminalSignalRService {

  private hubConnection: signalR.HubConnection;
  private stripeResponseSubject = new Subject<any>();
  public stripeResponse$ = this.stripeResponseSubject.asObservable();

  // Resolves with this browser's connection id once connected (null if the connection failed), so it can be sent
  // with the terminal request and the server can reply to this connection only
  public async startConnection(baseUrl): Promise<string | null> {
    baseUrl = baseUrl.replace('/api', '/');
    this.hubConnection = new signalR.HubConnectionBuilder()
      .withUrl(baseUrl + 'StripePaymentHub') // Replace with your SignalR hub URL
      .build();

    try {
      await this.hubConnection.start();
      console.log('SignalR connection started');
      return this.hubConnection.connectionId;
    } catch (err) {
      console.error('Error while starting SignalR connection: ' + err);
      return null;
    }
  }

  public addStripeResponseListener(listenerString : string): void {
    this.hubConnection.on(listenerString, (response : any) => {
      console.log('Stripe response received:', response);
      this.stripeResponseSubject.next(response);
    });
  }

  public stopConnection(): void {
    if (this.hubConnection && this.hubConnection.state === signalR.HubConnectionState.Connected) {
      this.hubConnection.stop()
      .then(() => console.log('SignalR connection stopped'))
      .catch(err => console.error('Error while stopping SignalR connection: ' + err));
    }else{
      console.log('No active SignalR connection to stop');
    }
  }
}
